export default {
  eyebrow: 'Filter',
  heading: 'Find articles.',
  heading_size: 'h4',
  copy: null,
  cta: [],
  component: 'm-filter-latest',
}
